"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));

var _Badge = _interopRequireDefault(require("@material-ui/core/Badge"));

var _ProfileMenu = _interopRequireDefault(require("./ProfileMenu"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = _interopRequireDefault(require("./styles"));

var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _Hamburger = _interopRequireDefault(require("./Hamburger"));

var _MenuLinks = _interopRequireDefault(require("./MenuLinks"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Header = function Header(_ref) {
  var classes = _ref.classes,
      currentOffice = _ref.currentOffice,
      links = _ref.links,
      logout = _ref.logout,
      offices = _ref.offices,
      setCurrentOffice = _ref.setCurrentOffice;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_AppBar["default"], {
    position: "static"
  }, /*#__PURE__*/_react["default"].createElement(_Toolbar["default"], {
    disableGutters: true
  }, /*#__PURE__*/_react["default"].createElement(_Hamburger["default"], {
    links: links
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/",
    exact: true,
    className: classes.titleLogo
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "LJ Hooker",
    className: classes.titleLogoImage,
    src: "https://assets.ljhooker.com/cache/48fd4b3ac18058bdc6db3233789a5d472c8e1ebe.svg",
    title: "LJ Hooker"
  })), /*#__PURE__*/_react["default"].createElement(_MenuLinks["default"], {
    links: links
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.grow
  }), /*#__PURE__*/_react["default"].createElement(_ProfileMenu["default"], {
    currentOffice: currentOffice,
    logout: logout,
    offices: offices,
    setCurrentOffice: setCurrentOffice
  }))));
};

Header.propTypes = {
  classes: _propTypes["default"].object.isRequired,
  currentOffice: _propTypes["default"].object,
  listingActionCardCount: _propTypes["default"].number,
  logout: _propTypes["default"].func,
  offices: _propTypes["default"].array,
  setCurrentOffice: _propTypes["default"].func
};
Header.defaultProps = {
  classes: {},
  currentOffice: {},
  links: [],
  logout: function logout() {},
  offices: [],
  setCurrentOffice: function setCurrentOffice() {}
};

var _default = (0, _withStyles["default"])(_styles["default"])(Header);

exports["default"] = _default;